import React, { Suspense } from "react";
import Card, { CardBody } from "../../../Components/base/Card";
import PageWrapper from "../../../Components/layout/PageWrapper";
import Page from "../../../Components/layout/Page";

const LOADING = (
  <PageWrapper>
    <Page>
      <div className="row h-100">
        <div className="col-lg-6">
          <Card stretch>
            <CardBody>
              <div />
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-6">
          <Card stretch="semi">
            <CardBody>
              <div />
            </CardBody>
          </Card>
          <Card stretch="semi">
            <CardBody>
              <div />
            </CardBody>
          </Card>
        </div>
      </div>
    </Page>
  </PageWrapper>
);

const Content = ({ children }) => {
  return (
    <main className="content">
      <Suspense fallback={LOADING}>
        {children}
      </Suspense>
    </main>
  );
};

export default Content;
